/* eslint-disable arrow-body-style */

import http from '@gp/utils/httpTS';

import type { IBaseResponse } from '@home/types/common';
import type { ICategoryMetricsData } from '@gp/types/metrics';

export const fetchMetrics = async (): IBaseResponse<ICategoryMetricsData | null> => {
  return http({
    url: '/api/v1/globalpedia_pc/metrics/list',
    method: 'GET',
    params: {},
    rawData: true,
  }) as any;
};
